import type { ImageAspectRatio } from '@shared/types/image.ts';
import { type IntentResult, isLayoutIntent } from '@shared/types/types.ts';
import type { OnEx } from '@tilelist/domain/experiments/OnEx.ts';

export type Columns = 'one-two' | 'two-three';

export const ALLOWED_GALLERY_LAYOUT_PARAMS = ['gp', 'gl', 'gq'] as const;
export type GalleryLayoutParam = (typeof ALLOWED_GALLERY_LAYOUT_PARAMS)[number];

export type GalleryLayout = {
    imageAspectRatio: ImageAspectRatio;
    layoutParam: string;
    columns: Columns;
};

export const GALLERY_PORTRAIT: GalleryLayout = {
    imageAspectRatio: 'portrait',
    layoutParam: 'gp',
    columns: 'two-three',
};

export const GALLERY_LANDSCAPE: GalleryLayout = {
    imageAspectRatio: 'landscape',
    layoutParam: 'gl',
    columns: 'one-two',
};

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const GALLERY_LANDSCAPE_TWO_COLUMN: GalleryLayout = {
    ...GALLERY_LANDSCAPE,
    columns: 'two-three',
    imageAspectRatio: 'landscape-two-column',
};

export const GALLERY_QUAD: GalleryLayout = {
    imageAspectRatio: 'quad',
    layoutParam: 'gq',
    columns: 'two-three',
};

export function getGalleryLayout(
    intents: IntentResult[],
    layoutQueryParam?: GalleryLayoutParam,
    onex?: OnEx,
): GalleryLayout {
    const resolved = resolveGalleryLayout(intents, layoutQueryParam);
    return applyExperimentOverride(resolved, onex);
}

function resolveGalleryLayout(intents: IntentResult[], layoutQueryParam?: GalleryLayoutParam): GalleryLayout {
    if (layoutQueryParam) {
        return getGalleryLayoutForParam(layoutQueryParam);
    }

    const layoutIntent = intents?.find(isLayoutIntent);
    switch (layoutIntent?.name) {
        case 'GALLERY_PORTRAIT':
            return GALLERY_PORTRAIT;
        case 'GALLERY_LANDSCAPE':
            return GALLERY_LANDSCAPE;
        case 'GALLERY_QUAD':
            return GALLERY_QUAD;
        default:
            return GALLERY_PORTRAIT;
    }
}

/**
 *
 *
 *
 *
 *
 *
 */
function applyExperimentOverride(layout: GalleryLayout, onex?: OnEx): GalleryLayout {
    if (layout === GALLERY_LANDSCAPE && onex?.isExperimentGroup('GALLERY_LANDSCAPE_TWO_COLUMN', 'E3822B')) {
        return GALLERY_LANDSCAPE_TWO_COLUMN;
    }
    return layout;
}

export function getGalleryLayoutForParam(layoutParam?: GalleryLayoutParam): GalleryLayout {
    switch (layoutParam) {
        case 'gp':
            return GALLERY_PORTRAIT;
        case 'gl':
            return GALLERY_LANDSCAPE;
        case 'gq':
            return GALLERY_QUAD;
        default:
            return GALLERY_PORTRAIT;
    }
}

export function isGalleryLayoutParam(value: string | undefined): value is GalleryLayoutParam {
    return ALLOWED_GALLERY_LAYOUT_PARAMS.some((p) => p === value);
}
